import React from 'react';
import { Route } from 'react-router-dom';
import Frontpage from '../views/frontpage';
import Subpage from '../views/subpage';
import Apartments from '../views/apartments';
import Apartment from '../views/apartment';
import StyleGuide from '../views/styleguide';
import NotFound from '../views/notFound';
import Articles from '../views/articles/articles';
import * as documentTypes from '../constants/documentTypes';
import Article from '../views/article/article';
import ContactUs from '../views/contactUs';

const mapper = {
	[documentTypes.frontpage]: Frontpage,
	[documentTypes.subpage]: Subpage,
	[documentTypes.apartments]: Apartments,
	[documentTypes.apartment]: Apartment,
	[documentTypes.styleguide]: StyleGuide,
	[documentTypes.articles]: Articles,
	[documentTypes.article]: Article,
	[documentTypes.contactUs]: ContactUs,
};

const getRouteTemplateFromType = (type) => {
	const result = mapper[type] || NotFound;
	return result;
};

const mappedRoutes = routes => routes.map(route => (
	<Route exact path={route.Url} component={getRouteTemplateFromType(route.Type)} key={route.Id} />
));

export default mappedRoutes;
